module.exports = __webpack_public_path__ + "img/面试通.c02e3169.png";